/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function AppsAndScripts(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4807 0.931632C13.6247 0.960483 13.759 1.03129 13.8645 1.13671L18.0305 5.3037C18.1709 5.44432 18.2502 5.63523 18.2502 5.83398V18.334C18.2499 18.7219 17.9551 19.0415 17.5774 19.0801L17.5002 19.084H3.4172V17.584H16.7502V7.41698H12.5002C12.4517 7.41698 12.4045 7.41113 12.3586 7.40234C12.3557 7.40178 12.3527 7.40195 12.3498 7.40136C12.2615 7.38336 12.1797 7.3488 12.1057 7.30273C12.098 7.29796 12.0898 7.2941 12.0822 7.28905C11.992 7.22829 11.9172 7.14783 11.8606 7.05468C11.8577 7.04994 11.8555 7.04483 11.8527 7.04003C11.7891 6.92983 11.7503 6.80333 11.7502 6.66698V2.41698H4.9172V7.41698H3.4172V1.66698L3.43185 1.51952C3.46073 1.37554 3.53155 1.24209 3.63693 1.13671C3.77758 0.996076 3.9683 0.916984 4.1672 0.916984H13.3342L13.4807 0.931632ZM5.22775 9.99999L2.72775 12.5L5.22775 15L4.1672 16.0605L1.13693 13.0303C0.844034 12.7374 0.844034 12.2626 1.13693 11.9697L4.1672 8.93944L5.22775 9.99999ZM10.5305 11.9697C10.8231 12.2626 10.8231 12.7374 10.5305 13.0303L7.50021 16.0605L6.43966 15L8.93966 12.5L6.43966 9.99999L7.50021 8.93944L10.5305 11.9697Z"
        fill="#35424F"
      />
    </svg>
  )
}

AppsAndScripts.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default AppsAndScripts
